import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

import { setSelectedSite } from '../../../site-detail/store/actions/ui.actions';
import { SecurityService } from '../../services/SecurityService';

@Injectable()
export class AuthEffects {
    private readonly actions$ = inject(Actions);
    private readonly oidcSecurityService = inject(OidcSecurityService);
    private readonly securityService = inject(SecurityService);

    refreshTokenOnSiteSelected$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(setSelectedSite),
                map(({ siteID }) => siteID),
                distinctUntilChanged(),
                switchMap(() => this.refreshOrLogin()),
            ),
        { dispatch: false },
    );

    private refreshOrLogin() {
        return this.oidcSecurityService.forceRefreshSession().pipe(
            catchError(() => {
                const authConfigId = this.securityService.getAuthConfigId();
                this.securityService.login(authConfigId);
                return of(null);
            }),
        );
    }
}
